module.exports = __webpack_public_path__ + "fonts/subset-mBank-LightItalic.5463a653.woff2";